export const SUBSCRIPTION_LEVELS = {
  LEVEL_100: 100,
  LEVEL_200: 200,
  LEVEL_300: 300,
  LEVEL_400: 400,
  LEVEL_500: 500,
  LEVEL_600: 600,
  LEVEL_700: 700,
  LEVEL_800: 800,
  LEVEL_900: 900,
  LEVEL_1000: 1000,
/*   LEVEL_1100: 1100,
  LEVEL_1200: 1200,
  LEVEL_1300: 1300, */
  ADMIN: 9999,
};

export function isAdmin(user) {
  return user?.subscriptionLevel === SUBSCRIPTION_LEVELS.ADMIN;
}

export function hasAccess(user, requiredLevel, courseSlug = null) {
/*   console.log("ACCESS CHECK:", { 
    courseSlug, requiredLevel, subscriptionLevel: user?.subscriptionLevel, courses: user?.courses,
  }) */

  if (!user) return false;
  if (isAdmin(user)) return true;
  
  if(courseSlug && Array.isArray(user.courses)) {  //course based entry here
    const course = user.courses.find(
      (c) => c.courseSlug === courseSlug && c.status === "active" 
    );
    return Number(course?.level || 0) >= requiredLevel;
  }
  if(typeof user.subscriptionLevel !== "number") return false;
  return user.subscriptionLevel >= requiredLevel;
} 

//later add a level ranking badge 
export function getUserRank(level) {
  if (level >= SUBSCRIPTION_LEVELS.ADMIN) return "Admin";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_1000) return "Level 1000";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_900) return "Level 900";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_800) return "Level 800";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_700) return "Level 700";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_600) return "Level 600";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_500) return "Level 500";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_400) return "Level 400";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_300) return "Level 300";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_200) return "Level 200";
  if (level >= SUBSCRIPTION_LEVELS.LEVEL_200) return "Level 100";
  return "Guest";
}


export const getRankImage = (rankNumber) => {
  try {
    return require(`../images/content-numbers/${rankNumber}.png`);
  } catch (err) {
    console.error(`Rank image not found for rank ${rankNumber}`);
    return null;
  }
};

